"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = exports.HttpResponse = exports.HttpClient = void 0;
var axios_1 = require("axios");
var HttpClient = /** @class */ (function () {
    function HttpClient() {
        this._axios_instance = axios_1.default.create({
            baseURL: '/api/',
        });
    }
    HttpClient.get_instance = function () {
        if (HttpClient._instance === null) {
            HttpClient._instance = new HttpClient();
        }
        return HttpClient._instance;
    };
    HttpClient.prototype.set_base_url = function (base_url) {
        this._axios_instance.defaults.baseURL = base_url;
    };
    HttpClient.prototype.set_default_headers = function (headers) {
        /* istanbul ignore next */
        this._axios_instance.defaults.headers = headers;
    };
    // NOTE: Calling axios.get<string>(...) does NOT necessarily return
    // a string. Use HttpClient.get_file instead, as it passes the proper
    // arguments to axios so that it returns a blob. The blob can then be
    // converted to a string with blob_to_string in utils.ts.
    HttpClient.prototype.get = function (url, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = HttpResponse.bind;
                        return [4 /*yield*/, this._axios_instance.get(url, { onDownloadProgress: options.on_download_progress })];
                    case 1: return [2 /*return*/, new (_a.apply(HttpResponse, [void 0, _b.sent()]))()];
                    case 2:
                        e_1 = _b.sent();
                        response = get_axios_response(e_1);
                        throw new HttpError(response.status, response.data, url, response.headers);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HttpClient.prototype.get_file = function (url, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_2, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = HttpResponse.bind;
                        return [4 /*yield*/, this._axios_instance.get(url, { responseType: "blob", onDownloadProgress: options.on_download_progress })];
                    case 1: return [2 /*return*/, new (_a.apply(HttpResponse, [void 0, _b.sent()]))()];
                    case 2:
                        e_2 = _b.sent();
                        response = get_axios_response(e_2);
                        throw new HttpError(response.status, response.data, url, response.headers);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HttpClient.prototype.post = function (url, data, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_3, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = HttpResponse.bind;
                        return [4 /*yield*/, this._axios_instance.post(url, data, { onUploadProgress: options.on_upload_progress })];
                    case 1: return [2 /*return*/, new (_a.apply(HttpResponse, [void 0, _b.sent()]))()];
                    case 2:
                        e_3 = _b.sent();
                        response = get_axios_response(e_3);
                        throw new HttpError(response.status, response.data, url, response.headers);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HttpClient.prototype.put = function (url, data, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_4, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = HttpResponse.bind;
                        return [4 /*yield*/, this._axios_instance.put(url, data, { onUploadProgress: options.on_upload_progress })];
                    case 1: return [2 /*return*/, new (_a.apply(HttpResponse, [void 0, _b.sent()]))()];
                    case 2:
                        e_4 = _b.sent();
                        response = get_axios_response(e_4);
                        throw new HttpError(response.status, response.data, url, response.headers);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HttpClient.prototype.patch = function (url, data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_5, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = HttpResponse.bind;
                        return [4 /*yield*/, this._axios_instance.patch(url, data)];
                    case 1: return [2 /*return*/, new (_a.apply(HttpResponse, [void 0, _b.sent()]))()];
                    case 2:
                        e_5 = _b.sent();
                        response = get_axios_response(e_5);
                        throw new HttpError(response.status, response.data, url, response.headers);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HttpClient.prototype.delete = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_6, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = HttpResponse.bind;
                        return [4 /*yield*/, this._axios_instance.delete(url)];
                    case 1: return [2 /*return*/, new (_a.apply(HttpResponse, [void 0, _b.sent()]))()];
                    case 2:
                        e_6 = _b.sent();
                        response = get_axios_response(e_6);
                        throw new HttpError(response.status, response.data, url, response.headers);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /* istanbul ignore next */
    HttpClient.prototype.authenticate = function (auth_token) {
        this._axios_instance.defaults.headers.common['Authorization']
            = "Token " + auth_token;
    };
    HttpClient._instance = null;
    return HttpClient;
}());
exports.HttpClient = HttpClient;
function get_axios_response(error) {
    var response = error.response;
    if (response === undefined) {
        /* istanbul ignore next */
        throw error;
    }
    return response;
}
var HttpResponse = /** @class */ (function () {
    function HttpResponse(args) {
        this.data = args.data;
        this.status = args.status;
        this.headers = args.headers;
    }
    return HttpResponse;
}());
exports.HttpResponse = HttpResponse;
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(status, data, url, headers) {
        var _newTarget = this.constructor;
        if (url === void 0) { url = ''; }
        if (headers === void 0) { headers = {}; }
        var _this = this;
        var actual_proto = _newTarget.prototype;
        _this = _super.call(this, 'HTTP response error: ' + status) || this;
        _this.__proto__ = actual_proto;
        _this.status = status;
        _this.data = data;
        _this.url = url;
        _this.headers = headers;
        return _this;
    }
    // tslint:disable-next-line:naming-convention
    HttpError.prototype.toString = function () {
        return 'HTTP response status: '
            + (this.status.toString() + "\n" + JSON.stringify(this.data));
    };
    return HttpError;
}(Error));
exports.HttpError = HttpError;
//# sourceMappingURL=http_client.js.map